/**
 * http://beautifytools.com/xml-to-json-converter.php
 */
import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import CorrectIcon from "@material-ui/icons/ThumbUp";
import IncorrectIcon from "@material-ui/icons/ThumbDown";
import PlayIcon from "@material-ui/icons/VolumeUp";
import IconButton from "@material-ui/core/IconButton";
import CheckedIcon from "@material-ui/icons/CheckCircle";
import NotCheckedIcon from "@material-ui/icons/HighlightOff";
import Fab from "@material-ui/core/Fab";
import Button from "@material-ui/core/Button";
import { img } from "../../config";
import { getResource } from "../../tools";
import "./TheWords.scss";

const useStyles = makeStyles((theme) => ({
  TheWords: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& > div": {
      width: 700,
      maxWidth: "100%",
      background: "#fff",
      padding: 20,
      maxHeight: "100%",
      overflow: "auto",
    },
  },
  menu: {
    textAlign: "center",
    width: "100%",
    "& h2": {
      color: theme.palette.primary.main,
    },
    "& img": {
      width: 400,
      maxWidth: "100%",
      marginBottom: 20,
    },
    "& > div": {
      border: "3px solid #C3CCE9",
      width: 400,
      maxWidth: "100%",
      textAlign: "center",
      cursor: "pointer",
      borderRadius: 5,
      marginBottom: 5,
      padding: 5,
      background: "#fff",
      display: "inline-block",
      "&:hover": {
        background: "#EFF3FA",
      },
    },
  },
  cards: {
    "& > h3": {
      textAlign: "center",
    },
  },
  action: {
    textAlign: "center",
    verticalAlign: "middle",
    display: "block",
    "& button": {
      margin: "0 3px",
      verticalAlign: "middle",
    },
    "& > span": {
      display: "inline-block",
      minWidth: 53,
      verticalAlign: "middle",
      userSelect: "none",
    },
  },
  done: {
    color: "#1d9021",
    marginRight: 5,
    float: "right",
  },
  notDone: {
    color: "#ccc",
    marginRight: 5,
    float: "right",
  },
  "@media(max-width: 850px)": {},
}));

let timeout1 = 0;
const bg1 = `url("${img("flip-back4.jpg")}")`;
const bg2 = `url("${img("flip-back3.jpg")}")`;

function TheWords(props) {
  const classes = useStyles();
  const [state, setState] = useState("menu");
  const [data, setData] = useState(false);
  const [flashcards, setFlashcards] = useState([]);
  const [complete, setComplete] = useState([false, false]);
  const [finished, setFinished] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const { exercise, startStats, finishExercise, action, type, close } =
    props.exerciseProps;
  const len = data.length;
  const ref = useRef(null);

  useEffect(() => {
    startStats(type);
    return () => {
      clearTimeout(timeout1);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let fileName = exercise.dataUrl;
    let idx = fileName.lastIndexOf("/");
    fileName = fileName.substr(idx + 1);
    idx = fileName.lastIndexOf(".");
    fileName = fileName.substr(0, idx) + ".json";
    const url = `TheWords/${fileName}`;
    getResource(url)
      .then((response) => {
        const newData = formatData(response);
        setData(newData);
      })
      .catch((e) => console.log(e));
  }, [exercise]);

  const play = (fileName) => {
    if (!fileName) return;
    action();
    const url = `https://platforma.szybkiangielski.pl/data/dzwieki/${fileName}`;
    props.media.play(url);
  };

  const start = (exType = false) => {
    exType && setState(exType);
    ref.current && ref.current.classList.remove("active");
    setFinished(false);
    setFlashcards(shuffle([...data]));
  };

  const drawMenu = () => {
    return (
      <div className={classes.menu}>
        <h2>Flashcards</h2>
        <img src={img("Flashcards.jpg")} alt="" />
        <div onClick={() => start("pol-ang")}>
          <span>POLSKI -> ANGIELSKI</span>
          {complete[0] && <CheckedIcon className={classes.done} />}
          {!complete[0] && <NotCheckedIcon className={classes.notDone} />}
        </div>
        <div onClick={() => start("ang-pol")}>
          <span>ANGIELSKI -> POLSKI</span>
          {complete[1] && <CheckedIcon className={classes.done} />}
          {!complete[1] && <NotCheckedIcon className={classes.notDone} />}
        </div>
        {complete[0] && complete[1] && (
          <span className={classes.action}>
            <Button variant="outlined" color="secondary" onClick={close}>
              Zamknij
            </Button>
          </span>
        )}
      </div>
    );
  };

  const flipCard = () => {
    ref.current.classList.add("active");
    play(flashcards[0].fileName);
    timeout1 = setTimeout(() => {
      setIsActive(true);
    }, 250);
  };

  const correct = () => {
    action();
    setIsActive(false);
    if (flashcards.length > 1) {
      const newFlashcards = [...flashcards];
      ref.current.classList.remove("active");
      timeout1 = setTimeout(() => {
        newFlashcards.shift();
        setFlashcards(newFlashcards);
      }, 100);
    } else {
      completePart(state === "pol-ang" ? 0 : 1);
    }
  };

  const incorrect = () => {
    action();
    setIsActive(false);
    ref.current.classList.remove("active");
    if (flashcards.length > 1) {
      const newFlashcards = [...flashcards];
      timeout1 = setTimeout(() => {
        const currentCard = newFlashcards.shift();
        newFlashcards.push(currentCard);
        setFlashcards(newFlashcards);
      }, 100);
    }
  };

  const completePart = (no) => {
    const cp = [...complete];
    cp[no] = true;
    props.media.finish();
    setFinished(true);
    setComplete(cp);
    if (cp[0] && cp[1]) {
      finishExercise();
    }
  };

  const drawCard = () => {
    const word = flashcards[0];

    return (
      <div className="tw-flip-cards">
        <div ref={ref} className="tw-flip-card">
          <div className="tw-flip-card-inner">
            <div className="tw-flip-card-front" onClick={flipCard}>
              <div style={{ backgroundImage: bg1 }}>
                {state === "pol-ang" && <span>{word.pol}</span>}
                {state === "ang-pol" && <span>{word.ang}</span>}
              </div>
            </div>
            <div className="tw-flip-card-back">
              <div style={{ backgroundImage: bg2 }}>
                {state === "pol-ang" && <span>{word.ang}</span>}
                {state === "ang-pol" && <span>{word.pol}</span>}
              </div>
            </div>
          </div>
        </div>
        <div
          className="tw-actions"
          style={isActive ? { opacity: 1 } : { opacity: 0 }}
        >
          <IconButton
            size="medium"
            className="tw-play"
            onClick={() => play(flashcards[0].fileName)}
            disabled={!isActive}
          >
            <PlayIcon />
          </IconButton>
          {!finished && (
            <Fab
              size="large"
              color="secondary"
              className="tw-incorrect"
              onClick={incorrect}
              disabled={!isActive}
            >
              <IncorrectIcon />
            </Fab>
          )}
          {!finished && (
            <Fab
              size="large"
              color="secondary"
              className="tw-correct"
              onClick={correct}
              disabled={!isActive}
            >
              <CorrectIcon />
            </Fab>
          )}
        </div>
      </div>
    );
  };

  const drawCards = () => {
    if (!flashcards.length) return "";
    const currentNo = len - flashcards.length + 1;

    return (
      <div className={classes.cards}>
        <h3>{flashcards[0].category}</h3>
        {(state === "pol-ang" || state === "ang-pol") && drawCard()}
        <div className={classes.action}>
          {!finished && (
            <span>
              {currentNo}/{len}{" "}
            </span>
          )}
          {finished && (
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setState("menu")}
            >
              Menu
            </Button>
          )}
          {finished && (
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => start()}
            >
              Restart
            </Button>
          )}
        </div>
      </div>
    );
  };

  if (!data)
    return (
      <h3 style={{ textAlign: "center", color: "#999" }}>
        Pobieram dane ćwiczenia...
      </h3>
    );

  return (
    <div className={classes.TheWords}>
      <div>
        {state === "menu" && drawMenu()}
        {(state === "pol-ang" || state === "ang-pol") && drawCards()}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    media: state.media,
    mobile: state.mobile,
  };
};

function shuffle(array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

function formatData(response) {
  const newData = [];
  response.wyrazy.kategoria.forEach((obj) => {
    const category = obj._nazwa;
    obj.wyraz.forEach((word) => {
      const fileName =
        word.plik !== ""
          ? word._plik.trim().replace(/ /g, "-") + ".mp3"
          : false;
      newData.push({ ang: word._ang, pol: word._pol, fileName, category });
    });
  });
  return shuffle(newData);
}

export default connect(mapStateToProps)(TheWords);
